import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ILightWeightUser } from '@fi-shared/models';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-role-users-list-dialog',
    template: `<fi-users-list-related-to-object-type [users$]="data"></fi-users-list-related-to-object-type>`,
    styleUrls: ['./role-users-list-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-role-users-list-dialog' },
    standalone: false,
})
export class RoleUsersListDialogComponent extends FiDialogsContentBase<
    BehaviorSubject<ILightWeightUser[]>,
    undefined
> {}
